import { useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { getBackgroundLocation } from '@/lib/settingsModal';

/** Reset window scroll on forward navigations (PUSH/REPLACE) — an SPA keeps
 * the previous page's scroll position otherwise, so opening an offer from the
 * bottom of a long SERP landed mid-page. POP (back/forward) is left alone so
 * the browser restores the SERP position on Back.
 *
 * Modal navigations (the settings overlay, carrying `backgroundLocation`) are
 * also left alone: the page underneath stays mounted and must keep its scroll
 * position — resetting it would defeat the overlay's whole point. */
export function ScrollToTop() {
  const location = useLocation();
  const navType = useNavigationType();
  const isModalNav = getBackgroundLocation(location) != null;

  /**
   * TYLKO ZMIANA STRONY (ścieżki), nigdy sama zmiana typu nawigacji. Do 29.09 w zależnościach
   * stał `navType`: po „wstecz” (POP) pierwsza podmiana adresu w miejscu (REPLACE — wyszukiwarka
   * zapisuje tak kadr mapy i filtry) zmieniała typ na REPLACE i przewijała stronę na górę, choć
   * strona była ta sama. Zmierzone w kontroli powrotu z oferty: scrollY 900 → 0.
   */
  const poprzedniaSciezka = useRef(location.pathname);
  useLayoutEffect(() => {
    const zmianaStrony = poprzedniaSciezka.current !== location.pathname;
    poprzedniaSciezka.current = location.pathname;
    if (zmianaStrony && navType !== 'POP' && !isModalNav) window.scrollTo(0, 0);
  }, [location.pathname, navType, isModalNav]);

  return null;
}
